import { Injectable } from '@angular/core';

import { ApiService } from '@core/services/api.service';
import { map } from 'rxjs/operators';

import { IdentityModel } from '../models/identity.model';
import { SignInModel } from '../models/sign-in.model';
import { SignUpInterviewModel } from '../models/sign-up-interview.model';
import { SignUpPersonalDataModel } from '../models/sign-up-personal-data.model';
import { SignUpSecurityModel } from '../models/sign-up-security.model';
import { SignUpModel } from '../models/sign-up.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends ApiService {
  signUp(model: SignUpModel, telegramId?: number) {
    return this.http
      .post<IdentityModel>(this.getApiUrl('authentications/sign-up'), { ...model, telegramId })
      .pipe(map(response => new IdentityModel().setAttributes(response)));
  }

  getUser() {
    return this.http
      .get<IdentityModel>(this.getApiUrl('authentications/get-user'))
      .pipe(map(response => new IdentityModel().setAttributes(response)));
  }

  signIn(model: SignInModel, telegramId?: number) {
    return this.http
      .post<IdentityModel>(this.getApiUrl('authentications/sign-in'), { ...model, telegramId })
      .pipe(map(response => new IdentityModel().setAttributes(response)));
  }

  signUpGoogle(model: { code: string }) {
    return this.http
      .get<IdentityModel>(this.getApiUrl(`authentications/google?code=${model.code}`))
      .pipe(map(response => new IdentityModel().setAttributes(response)));
  }

  signUpStepPersonalData(model: SignUpPersonalDataModel) {
    return this.http
      .put<IdentityModel>(this.getApiUrl('authentications/sign-up-step-personal-data'), model)
      .pipe(map(response => new IdentityModel().setAttributes(response)));
  }

  signUpStepSecurity(model: SignUpSecurityModel) {
    return this.http
      .put<IdentityModel>(this.getApiUrl('authentications/sign-up-step-security'), model)
      .pipe(map(response => new IdentityModel().setAttributes(response)));
  }

  signUpStepInterview(model: SignUpInterviewModel) {
    return this.http
      .put<IdentityModel>(this.getApiUrl('authentications/sign-up-step-questions'), model)
      .pipe(map(response => new IdentityModel().setAttributes(response)));
  }
}
